var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule-alert-wrapper"},[_c('b-form-group',[_c('b-form-radio-group',{staticClass:"rule-alert",attrs:{"options":_vm.options.alert},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }